
// tabs/RefTab.jsx - Reference information tab (ONLY the ref fields)
import React from 'react';
import { Box, Grid, Stack, TextInput, Group, Text, Checkbox, NumberInput, Button } from '@mantine/core';

const RefTab = ({ selectedLineId, lineDetail, setLineDetail }) => {
  return (
    <Box p="md">
      <Grid gutter="md">
        {/* Left Column */}
        <Grid.Col span={4}>
          <Stack spacing="xs">
            <Group spacing="xs" align="flex-end">
              <Text size="sm" fw={500} w={80}>MFG:</Text>
              <TextInput
                value={lineDetail.mfg}
                variant="filled"
                size="sm"
                style={{ flex: 1 }}
                onChange={(e) => setLineDetail(prev => ({ ...prev, mfg: e.target.value }))}
              />
            </Group>

            <Group spacing="xs" align="flex-end">
              <Text size="sm" fw={500} w={80}>CAGE:</Text>
              <TextInput
                value={lineDetail.cage}
                variant="filled"
                size="sm"
                style={{ flex: 1 }}
                onChange={(e) => setLineDetail(prev => ({ ...prev, cage: e.target.value }))}
              />
            </Group>

            <Group spacing="xs" align="flex-end">
              <Text size="sm" fw={500} w={80}>Cust P/N:</Text>
              <TextInput
                value={lineDetail.custPN}
                variant="filled"
                size="sm"
                style={{ flex: 1 }}
                onChange={(e) => setLineDetail(prev => ({ ...prev, custPN: e.target.value }))}
              />
            </Group>

            <Group spacing="xs" align="flex-end">
              <Text size="sm" fw={500} w={80}>Test Rep:</Text>
              <TextInput
                value={lineDetail.testRep}
                variant="filled"
                size="sm"
                style={{ flex: 1 }}
                onChange={(e) => setLineDetail(prev => ({ ...prev, testRep: e.target.value }))}
              />
              <Text size="sm" fw={500}>Rev:</Text>
              <TextInput
                value={lineDetail.rev}
                variant="filled"
                size="sm"
                w={60}
                onChange={(e) => setLineDetail(prev => ({ ...prev, rev: e.target.value }))}
              />
            </Group>

            <Group spacing="xs" align="flex-end">
              <Text size="sm" fw={500} w={80}>Ship on:</Text>
              <TextInput
                value={lineDetail.shipOn}
                variant="filled"
                size="sm"
                style={{ flex: 1 }}
                onChange={(e) => setLineDetail(prev => ({ ...prev, shipOn: e.target.value }))}
              />
              <Checkbox
                label="No Charge"
                checked={lineDetail.noCharge}
                onChange={(e) => setLineDetail(prev => ({ ...prev, noCharge: e.currentTarget.checked }))}
              />
            </Group>

            <Group spacing="xs" align="flex-end">
              <Text size="sm" fw={500} w={80}>Due on:</Text>
              <TextInput
                value={lineDetail.dueOn}
                variant="filled"
                size="sm"
                style={{ flex: 1 }}
                onChange={(e) => setLineDetail(prev => ({ ...prev, dueOn: e.target.value }))}
              />
              <Text size="sm" fw={500}>Priority:</Text>
              <TextInput
                value={lineDetail.priority}
                variant="filled"
                size="sm"
                w={60}
                onChange={(e) => setLineDetail(prev => ({ ...prev, priority: e.target.value }))}
              />
            </Group>

            <Group spacing="xs" align="flex-end">
              <Text size="sm" fw={500} w={80}>Req P/N:</Text>
              <TextInput
                value={lineDetail.reqPN}
                variant="filled"
                size="sm"
                style={{ flex: 1 }}
                onChange={(e) => setLineDetail(prev => ({ ...prev, reqPN: e.target.value }))}
              />
            </Group>
          </Stack>
        </Grid.Col>

        {/* Middle Column */}
        <Grid.Col span={4}>
          <Stack spacing="xs">
            <Group spacing="xs" align="flex-end">
              <Text size="sm" fw={500} w={80}>Mfg Lot #:</Text>
              <TextInput
                value={lineDetail.mfgLotNo}
                variant="filled"
                size="sm"
                style={{ flex: 1 }}
                onChange={(e) => setLineDetail(prev => ({ ...prev, mfgLotNo: e.target.value }))}
              />
            </Group>

            <Group spacing="xs" align="flex-end">
              <Text size="sm" fw={500} w={80}>Trace To:</Text>
              <TextInput
                value={lineDetail.traceTo}
                variant="filled"
                size="sm"
                style={{ flex: 1 }}
                styles={{ input: { fontWeight: 'bold', color: 'blue' } }}
                onChange={(e) => setLineDetail(prev => ({ ...prev, traceTo: e.target.value }))}
              />
            </Group>

            <Group spacing="xs" align="flex-end">
              <Text size="sm" fw={500} w={80}>Tag Info:</Text>
              <TextInput
                value={lineDetail.tagInfo}
                variant="filled"
                size="sm"
                style={{ flex: 1 }}
                styles={{ input: { fontWeight: 'bold', color: 'blue' } }}
                onChange={(e) => setLineDetail(prev => ({ ...prev, tagInfo: e.target.value }))}
              />
            </Group>

            <Group spacing="xs" align="flex-start">
              <Text size="sm" fw={500} w={80}>Note:</Text>
              <TextInput
                value={lineDetail.note}
                variant="filled"
                size="sm"
                style={{ flex: 1 }}
                onChange={(e) => setLineDetail(prev => ({ ...prev, note: e.target.value }))}
              />
            </Group>
          </Stack>
        </Grid.Col>

        {/* Right Column */}
        <Grid.Col span={4}>
          <Stack spacing="xs">
            <Group spacing="xs" align="flex-end">
              <Text size="sm" fw={500} w={80}>Ship to:</Text>
              <NumberInput
                value={lineDetail.shipTo}
                variant="filled"
                size="sm"
                style={{ flex: 1 }}
                styles={{ input: { fontWeight: 'bold', color: 'blue' } }}
                onChange={(value) => setLineDetail(prev => ({ ...prev, shipTo: value }))}
              />
            </Group>

            <Group spacing="xs" align="flex-end">
              <Text size="sm" fw={500} w={80}>MFG:</Text>
              <TextInput
                value={lineDetail.mfgDetail}
                variant="filled"
                size="sm"
                style={{ flex: 1 }}
                onChange={(e) => setLineDetail(prev => ({ ...prev, mfgDetail: e.target.value }))}
              />
            </Group>

            <Group spacing="xs" align="flex-end">
              <Text size="sm" fw={500} w={80}>Category:</Text>
              <TextInput
                value={lineDetail.category}
                variant="filled"
                size="sm"
                style={{ flex: 1 }}
                styles={{ input: { fontWeight: 'bold', color: 'blue' } }}
                onChange={(e) => setLineDetail(prev => ({ ...prev, category: e.target.value }))}
              />
            </Group>

            <Group spacing="xs" align="flex-end" mt="md">
              <Text size="sm" fw={500} w={80}>Target Price:</Text>
              <NumberInput
                value={lineDetail.targetPrice}
                variant="filled"
                size="sm"
                style={{ flex: 1 }}
                styles={{ input: { fontWeight: 'bold', color: 'blue' } }}
                decimalScale={2}
                fixedDecimalScale
                onChange={(value) => setLineDetail(prev => ({ ...prev, targetPrice: value }))}
              />
            </Group>

            <Group spacing="xs" align="flex-end">
              <Text size="sm" fw={500} w={80}>S/N:</Text>
              <TextInput
                value={lineDetail.serialNumber}
                variant="filled"
                size="sm"
                style={{ flex: 1 }}
                styles={{ input: { fontWeight: 'bold', color: 'blue' } }}
                onChange={(e) => setLineDetail(prev => ({ ...prev, serialNumber: e.target.value }))}
              />
            </Group>

            {/* Color Picker Button */}
            <Group mt="sm" justify="flex-end">
              <Button 
                variant="default" 
                size="xs"
                style={{
                  background: 'linear-gradient(to right, red, yellow, green, blue)',
                  width: '40px',
                  height: '20px',
                  padding: 0
                }}
              />
            </Group>
          </Stack>
        </Grid.Col>
      </Grid>
    </Box>
  );
};

export default RefTab;